import  gql  from 'graphql-tag'

export const monthlyReport = gql`query MonthlyReport($startDate: Date, $endDate: Date) {
    monthlyReport(startDate: $startDate, endDate: $endDate) {
        monthlyHistorical
        {
            year
            month
            monthName
            inProcess
            finished
        }
    }
  }`;